import {
	buildStandaloneSearchBox,
	StandaloneSearchBoxOptions,
} from "@coveo/headless";
import { drhHeadlessEngine } from "../../system/engine/engine";

const options: StandaloneSearchBoxOptions = {
	numberOfSuggestions: 100,
	redirectionUrl: "/community-finder",
};

export const searchBox = buildStandaloneSearchBox(drhHeadlessEngine, {
	options,
});
